import React from 'react';
import { DropdownProvider } from '../../context/DropDownContext';
import ShoorahTestDropdown from './ShoorahTestDropdown';

const TestLayout = ({ children }) => {
  const testOptions = [
    { name: 'Dashboard', value: 1, path: '/test/tests-dashboard' },
    { name: 'B2C Users', value: 2, path: '/test/b2c' },
    { name: 'B2B Users', value: 3, path: '/test/b2b' },
    { name: 'API Partners', value: 4, path: '/test/partners' }
  ];
  return (
    <DropdownProvider options={testOptions}>
      <div>
        <ShoorahTestDropdown options={testOptions} />
        <div className="mt-4">{children}</div>
      </div>
    </DropdownProvider>
  );
};

export default TestLayout;
